import React from 'react';
import { EmptyDataContainer } from './EmptyData.styles';

interface Props {
    text: string;
    text2?: string;
    pending?: boolean;
    styles?: React.CSSProperties;
}

const EmptyData: React.FC<Props> = ({ text, text2, styles, pending = true }) => {
    if (text2) {
        return <EmptyDataContainer style={styles}>{!pending && <>{text}<br/>{text2}</>}</EmptyDataContainer>;
    }
    return <EmptyDataContainer style={styles}>{!pending && <>{text}</>}</EmptyDataContainer>;
};

export default EmptyData;
